// ** React Imports
import { Link } from 'react-router-dom'

// ** Third Party Components
import { setFetchOption } from 'features/private-views/dashboard/dashboardSlice'
import Proptypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { Breadcrumb, BreadcrumbItem } from 'reactstrap'
import './style.scss'

const BreadCrumbs = (props) => {
  // ** Props
  const {
    breadCrumbParent,
    breadCrumbParentLink,
    breadCrumbParentOnClick,
    breadCrumbParent2,
    breadCrumbParent2Link,
    breadCrumbParent2OnClick,
    breadCrumbParent3,
    breadCrumbParent3Link,
    breadCrumbParent3OnClick,
    breadCrumbActiveRaw,
    breadCrumbActive,
    onClickBreadCrumb,
  } = props
  const dispatch = useDispatch()

  return (
    <div
      className="d-flex align-items-center overflow-x-auto text-nowrap pb-1"
      data-testid="breadcrumbs"
    >
      <Breadcrumb className="mb-0" listClassName="flex-nowrap">
        {breadCrumbParent3 || breadCrumbParent3Link ? (
          <>
            <BreadcrumbItem tag="li" active className="text-primary" data-testid="breadcrumb-item-more">
              ...
            </BreadcrumbItem>
            {breadCrumbParent3 ? (
              <BreadcrumbItem tag="li" data-testid="breadcrumb-item-3">
                {breadCrumbParent3Link ? (
                  <Link
                    to={breadCrumbParent3Link}
                    className="text-decoration-none text-primary breadcrumb-hover"
                  >
                    <span className="text-primary ms-2 pointer">
                      {breadCrumbParent3}
                    </span>
                  </Link>
                ) : (
                  <span
                    onClick={breadCrumbParent3OnClick}
                    className="text-primary  ms-2 pointer"
                  >
                    {breadCrumbParent3}
                  </span>
                )}
              </BreadcrumbItem>
            ) : (
              ''
            )}
            <BreadcrumbItem tag="li" active className="text-primary" data-testid="breadcrumb-item-active">
              {breadCrumbActiveRaw ? (
                breadCrumbActive
              ) : (
                <span className="text-primary  ms-2 pointer">
                  {breadCrumbActive}
                </span>
              )}
            </BreadcrumbItem>
          </>
        ) : (
          <>
            <BreadcrumbItem tag="li" data-testid="breadcrumb-item-home">
              <Link
                to="/"
                className="text-decoration-none text-primary breadcrumb-hover"
                onClick={() => {
                  dispatch(
                    setFetchOption({
                      status: undefined,
                      page: 0,
                    }),
                  )
                }}
              >
                <span className="text-primary">Home</span>
              </Link>
            </BreadcrumbItem>
            {breadCrumbParent ? (
              <BreadcrumbItem tag="li" data-testid="breadcrumb-item-1">
                {breadCrumbParentLink ? (
                  <Link
                    to={breadCrumbParentLink}
                    className="text-decoration-none text-primary breadcrumb-hover"
                  >
                    {' '}
                    <span className="text-primary ms-2 pointer">
                      {breadCrumbParent}
                    </span>{' '}
                  </Link>
                ) : (
                  <span
                    onClick={breadCrumbParentOnClick}
                    className="text-primary  ms-2 pointer"
                  >
                    {breadCrumbParent}
                  </span>
                )}
              </BreadcrumbItem>
            ) : (
              ''
            )}
            {breadCrumbParent2 ? (
              <BreadcrumbItem tag="li" data-testid="breadcrumb-item-2">
                {breadCrumbParent2Link ? (
                  <Link
                    to={breadCrumbParent2Link}
                    className="text-decoration-none text-primary breadcrumb-hover"
                  >
                    <span className="text-primary  ms-2">
                      {breadCrumbParent2}
                    </span>
                  </Link>
                ) : (
                  <span
                    onClick={breadCrumbParent2OnClick}
                    className="text-primary  ms-2 pointer"
                  >
                    {breadCrumbParent2}
                  </span>
                )}
              </BreadcrumbItem>
            ) : (
              ''
            )}
            {Array.isArray(breadCrumbActive) ? (
              breadCrumbActive?.map((el, i) => {
                return (
                  <BreadcrumbItem
                    tag="li"
                    active
                    className="text-secondary"
                    data-testid={`breadcrumb-item-${el?.id}`}
                  >
                    {el?.id ===
                    breadCrumbActive[breadCrumbActive?.length - 1]?.id ? (
                      <span className="ms-2">{el?.label}</span>
                    ) : (
                      <Link
                        onClick={() => onClickBreadCrumb(el)}
                        className={`text-decoration-none breadcrumb-hover text-primary`}
                      >
                        <span className="ms-2">{el?.label}</span>
                      </Link>
                    )}
                  </BreadcrumbItem>
                )
              })
            ) : (
              <BreadcrumbItem tag="li" active className="text-secondary" data-testid="breadcrumb-item-active">
                {breadCrumbActiveRaw ? (
                  breadCrumbActive
                ) : (
                  <span className="text-secondary ms-2">
                    {breadCrumbActive}
                  </span>
                )}
              </BreadcrumbItem>
            )}
          </>
        )}
      </Breadcrumb>
    </div>
  )
}
export default BreadCrumbs

// ** PropTypes
BreadCrumbs.propTypes = {
  breadCrumbActive: Proptypes.string.isRequired,
}
